import React, { useState } from 'react';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import { app } from '../firebase';
import { useUser } from '../contexts/UserContext';
import { LEGAL_URLS } from '../helpers/Constants';
import PrimaryButton from '../components/buttons/PrimaryButton';

const db = getFirestore(app);

function AcceptConditionsModal() {
  const { user, setUser } = useUser();
  const [acceptedCgu, setAcceptedCgu] = useState(false);
  const [acceptedPrivacyPolicy, setAcceptedPrivacyPolicy] = useState(false);
  const [acceptedSubcontracting, setAcceptedSubcontracting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleValidate = async () => {
    if (!acceptedCgu) {
      setError('Vous devez accepter les CGU');
      return;
    }
    if (!acceptedPrivacyPolicy) {
      setError('Vous devez accepter la politique de confidentialité');
      return;
    }
    if (!acceptedSubcontracting) {
      setError("Vous devez accepter l'accord de sous-traitance");
      return;
    }

    setLoading(true);
    setError('');

    try {
      const userRef = doc(db, 'users', user.user.uid);
      await updateDoc(userRef, { acceptConditions: true });

      setUser({
        ...user,
        userData: {
          ...user.userData,
          acceptConditions: true,
        },
      });
    } catch (err) {
      console.error('Erreur lors de la validation des conditions :', err);
      setError('Une erreur est survenue. Veuillez réessayer.');
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4">
      <div
        className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="accept-conditions-title"
      >
        <h2 id="accept-conditions-title" className="mb-2 text-xl font-semibold text-gray-900">
          Acceptation des conditions
        </h2>
        <p className="mb-4 text-sm text-gray-600">
          Pour continuer à utiliser Trustymo, veuillez accepter les documents suivants.
        </p>

        <div className="mb-4 space-y-3">
          <label className="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={acceptedCgu}
              onChange={(e) => setAcceptedCgu(e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary"
            />
            <span>
              J&apos;accepte les{' '}
              <a
                href={LEGAL_URLS.CGU}
                target="_blank"
                rel="noreferrer"
                className="text-cyan-600 underline hover:text-cyan-800"
                onClick={(e) => e.stopPropagation()}
              >
                CGU
              </a>
              <span className="text-red-500"> *</span>
            </span>
          </label>

          <label className="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={acceptedPrivacyPolicy}
              onChange={(e) => setAcceptedPrivacyPolicy(e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary"
            />
            <span>
              J&apos;accepte la{' '}
              <a
                href={LEGAL_URLS.PRIVACY_POLICY}
                target="_blank"
                rel="noreferrer"
                className="text-cyan-600 underline hover:text-cyan-800"
                onClick={(e) => e.stopPropagation()}
              >
                politique de confidentialité
              </a>
              <span className="text-red-500"> *</span>
            </span>
          </label>

          <label className="flex cursor-pointer items-start gap-2 text-sm text-gray-700">
            <input
              type="checkbox"
              checked={acceptedSubcontracting}
              onChange={(e) => setAcceptedSubcontracting(e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary"
            />
            <span>
              J&apos;accepte l&apos;
              <a
                href={LEGAL_URLS.SUBCONTRACTING_AGREEMENT}
                target="_blank"
                rel="noreferrer"
                className="text-cyan-600 underline hover:text-cyan-800"
                onClick={(e) => e.stopPropagation()}
              >
                accord de sous-traitance
              </a>
              <span className="text-red-500"> *</span>
            </span>
          </label>
        </div>

        {error !== '' && (
          <p className="mb-3 text-center text-sm text-red-500">{error}</p>
        )}

        <div className="text-center">
          <PrimaryButton
            type="button"
            value="Valider"
            loading={loading}
            onClick={handleValidate}
          />
        </div>
      </div>
    </div>
  );
}

export default AcceptConditionsModal;
